<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-card
          flat
          tile
          style="background: linear-gradient(90deg, #056848 0%, #0ace8f 100%)"
        >
          <v-layout wrap justify-center pa-5 py-10>
            <v-flex xs12 text-center>
              <span
                style="
                  color: white;
                  font-family: poppinssemibold;
                  font-size: 25px;
                "
                >Our Eco Shops</span
              >
            </v-flex>
            <v-flex xs12>
              <v-layout wrap justify-center>
                <v-flex xs12 sm8 text-center pt-5>
                  <v-text-field
                    flat
                    solo
                     v-model="searchkey"
                    class="py-0 pa-0 rounded-xl"
                    label="Search Ecoshop..."
                  >
                    <template v-slot:append>
                      <v-btn text color="#056848" dark>
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm1 text-left pt-5>
                <v-img
                  src="./../../assets/search.png"
                  class="append-icon"
                  contain
                  style="
                    border: solid white 2px;
                    border-radius: 0px 15px 15px 0px;
                  "
                  max-width="77px"
                  max-height="60px"
                ></v-img>
              </v-flex> -->
              </v-layout>
            </v-flex>

            <v-layout wrap justify-center>
              <v-flex xs12 sm10 md6 text-center>
                <span
                  style="
                    color: white;
                    font-family: poppinsregular;
                    font-size: 16px;
                  "
                  >Discover eco-friendly stores near you and shop sustainable
                  products easily. Shop responsibly and support businesses that
                  care for the planet</span
                >
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center pt-16 px-2 px-xs-2 px-sm-5 px-md-5 px-lg-10 px-xl-10>
      <v-flex xs12 sm12 text-center>
        <v-layout wrap>
          <v-flex xs12 sm6 md4 lg3 pa-2 v-for="(item, i) in items" :key="i">
            <v-hover v-slot="{ hover }">
            <v-card flat class="rounded-lg" :style="hover ? 'border:solid #0E9267 2px' : ''">
              <router-link :to="'/ecoShop?shopname=' + item.shopname + '&id=' + item.ecoshopId">
              <v-layout wrap px-4 py-3>
                <v-flex xs2>
                  <v-img
                  v-if="hover"
                    src="./../../assets/icons/ecoshopIconGreen.png"
                  ></v-img>
                  <v-img
                  v-else
                    src="./../../assets/icons/ecoshopIconLight.png"
                  ></v-img>
                </v-flex>
                <v-flex xs10 text-left pl-2 align-self-center>
                  <span style="font-family: opensansbold; color: #000000;">{{ item.shopname }}</span>
                </v-flex>
              </v-layout>
              </router-link>
            </v-card>
          </v-hover>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  data() {
    return {
      items: [],
      searchkey:"",
    };
  },
  mounted() {
      this.getData();
  },

  watch: {
   
    searchkey() {
      this.getData();
      //this.currentPage=1
    },
  },

  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/ecoshop/list",
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
        params:{
          searchkey:this.searchkey
        }
      })
        .then((response) => {
          this.appLoading = false;
          this.items = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

  },
};
</script>
<style scoped>
.v-text-field.v-text-field--solo .v-input__control {
  min-height: 0px !important;
  padding: 0;
}
</style>